const getSymbolBasedOnSystem = (defaultSymbol: string, macSymbol: string) => {
  if (typeof navigator === "undefined") {
    return "";
  }

  return /Mac/.test(navigator.platform) ? macSymbol : defaultSymbol;
};

export const KEY_SYMBOLS_MAP: Record<string, string> = {
  $mod: getSymbolBasedOnSystem("Ctrl", "⌘"),
  Shift: "⇧",
  Alt: getSymbolBasedOnSystem("Alt", "⌥"),
  Backspace: getSymbolBasedOnSystem("⟵", "⌫"),
  Enter: getSymbolBasedOnSystem("Enter", "⏎"),
  Control: getSymbolBasedOnSystem("Ctrl", "⌃"),
};
